/**
 * Componente Modal reutilizável para exibir conteúdo em sobreposição.
 *
 * Este componente renderiza um modal que pode ser mostrado ou ocultado
 * com base na prop 'show'. O conteúdo do modal é passado como children.
 *
 * @module Modal
 */

import { Container, Content } from './Modal.Styles';

/**
 * Componente funcional que renderiza um modal.
 *
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.show - Controla a visibilidade do modal (true para mostrar, false para ocultar)
 * @param {React.ReactNode} props.children - Conteúdo a ser renderizado dentro do modal
 * @returns {JSX.Element|null} Componente modal ou null quando não deve ser exibido
 */
const Modal = ({ show, children }) => {
  // Não renderiza nada se o modal não deve ser exibido
  if (!show) return null;

  /**
   * Impede que cliques no conteúdo do modal propaguem para o container,
   * evitando que o modal seja fechado quando o usuário clica no conteúdo.
   *
   * @param {React.MouseEvent} e - Evento de clique
   */
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Container id="modal-backdrop">
      <Content onClick={handleModalContentClick}>{children}</Content>
    </Container>
  );
};

export default Modal;
